import { medicalMessagesEN } from './lib/intl/en-US';

export const programId = '5eda6d32df3bb61bc04a6f2e'; // DC Shoes program ID

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': medicalMessagesEN,
    },
};
